import axios from "axios";

export const axiosManager = axios.create({
    baseURL: import.meta.env.VITE_REACT_APP_API
})
